import React from "react";
import "./error.scss";
const Error = () => {
  return (
    <div className="error">
      
      <h1>404</h1>
      <h3>Page Not Found</h3>
    </div>
  );
};

export default Error;
